import React from 'react'
import { Grid, useMediaQuery } from '@mui/material'

import Radio from '_/components/inputs/Radio'
import { useFormContext } from 'react-hook-form'

import useStyles from '../styles'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

const NAME = 'isServiceMandatory'

export function MandatoryServiceField() {
  const styles = useStyles()
  const { watch } = useFormContext()
  const isBigScreen = useMediaQuery('(min-width:1400px)')
  const fontSize = isBigScreen ? '14px' : '12px'
  const { addProblemReadOnly } = useBudgetForm()

  return (
    <Grid className={styles.radioWrapper}>
      <Radio
        required
        name={NAME}
        label="O cliente pode aceitar o orçamento sem este serviço?"
        labelRadio1="Não, este serviço é obrigatório"
        labelRadio2="Sim, este serviço é opcional"
        radioGroupClasses={styles.radioGroup}
        radioClasses={styles.radioClasses}
        labelClasses={styles.label}
        defaultValue={watch(NAME)}
        valueRadio1
        valueRadio2={false}
        radioOptionLabel={{ fontSize, fontWeight: 400 }}
        disabled={addProblemReadOnly}
      />
    </Grid>
  )
}
